import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ShoreBadge, PlanBadge } from "@/components/shared";

const FALLBACK = "https://images.pexels.com/photos/8755712/pexels-photo-8755712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function ListingCard({ listing, featured = false }) {
  return (
    <Link
      to={`/made/${listing.slug}`}
      data-testid={`listing-card-${listing.slug}`}
      className={`group flex flex-col bg-[#FFFAF3] transition duration-200 hover:shadow-md relative ${
        featured
          ? "border-2 border-[#CDA434] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-1 before:bg-[#CDA434] before:z-10"
          : "border border-[#D6D3CB] hover:border-[#CDA434]"
      }`}
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-[#F8F1E7]">
        <img
          src={listing.image_url || FALLBACK}
          alt={listing.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <ShoreBadge shore={listing.shore} />
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between gap-2 mb-2">
          <span className="font-sans text-xs uppercase tracking-[0.15em] text-[#505A68]">
            {listing.category}
          </span>
          <PlanBadge plan={listing.plan} />
        </div>
        <h3 className="font-serif font-semibold text-xl text-[#1E1E2F] leading-snug group-hover:text-[#003366] transition-colors">
          {listing.name}
        </h3>
        <p className="mt-3 font-sans text-sm text-[#505A68] leading-relaxed flex-1">
          {listing.short_pitch}
        </p>
        <span className="mt-5 inline-flex items-center gap-1 font-sans text-sm font-semibold text-[#003366]">
          Open listing
          <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}
